class Permission
{
  constructor(parent_self) {
    this.parent_self = parent_self
    this.permissions = []
  }

  /**
   * Obtener los permisos asociados
   * @returns array
   */
  getPermissions() {
    return this.permissions
  }

  /**
   * Establecer permisos
   * @param {*} permissions
   */
  setPermissions(permissions) {
    this.permissions = permissions
  }

  /**
   * Establecer permisos del store
   */
  setStorePermissions() {
    this.permissions = this.parent_self.$store.state.auth.permissions
  }

  /**
   * Varifica si un permiso esta asociado
   * @param String permission_name
   * @returns boolean
   */
  validateHavePermission(permission_name) {
    let response = this.permissions.filter((permission) => {
      return permission_name == permission
    })
    return response.length > 0
  }
}

export default Permission
